var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconalertwarning = function SvgIconalertwarning(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Alerts/Warning_Large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Alerts/Warning_Large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0134471,1.00831116 L10.0134471,1.00831116 C9.5387001,0.954390203 9.07230901,1.16562172 8.7931343,1.56099863 L8.7931343,1.56099863 L0.109494271,16.9237537 L0.109494271,16.9237537 C-0.0664629574,17.3647335 -0.0287793903,17.8644594 0.211223965,18.2728023 C0.45122732,18.6811452 0.865582244,18.9505199 1.32980702,19 L18.6970871,19 C19.1480495,18.9241794 19.5435247,18.6499467 19.7785378,18.2500942 C20.0135509,17.8502418 20.0643313,17.365213 19.9173998,16.9237537 L19.9173998,16.9237537 L11.0995014,1.56099863 L11.0995014,1.56099863 C10.9628456,1.14770579 10.4210171,1.00831116 10.0134471,1.00831116 Z",
    id: "Path_506-3-path",
    fill: "#EE9B0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7181677,6.098465 C11.6688149,5.50918572 11.0883027,5.04002195 10.3591677,5.00013552 C9.99701224,4.99550452 9.64800598,5.10973333 9.39189136,5.31672247 C9.13577674,5.52371161 8.99443759,5.80577479 9.00016768,6.098465 L9.00016768,10.901535 C8.99443759,11.1942252 9.13577674,11.4762884 9.39189136,11.6832775 C9.64800598,11.8902667 9.99701224,12.0044955 10.3591677,11.9998645 C11.0883027,11.959978 11.6688149,11.4908143 11.7181677,10.901535 L11.7181677,6.098465 Z",
    id: "Path_506-3-path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.725211,14.5 C11.7428398,13.7272491 11.1496034,13.0724628 10.366211,13 C9.97754668,13.0054533 9.6090756,13.1709781 9.35065777,13.4562075 C9.09223994,13.7414369 8.96762784,14.120154 9.00721096,14.5 L9.00721096,14.5 C8.96762784,14.879846 9.09223994,15.2585631 9.35065777,15.5437925 C9.6090756,15.8290219 9.97754668,15.9945467 10.366211,16 C11.1496034,15.9275372 11.7428398,15.2727509 11.725211,14.5 Z",
    id: "Path_506-3-path",
    fill: "#FFFFFF"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconalertwarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.alert.warning.13ea04bbac77e1b67b8986d42b2bb40a.svg";